/**
 * The board's row actions that need a toast: duplicate and delete (Phase 20: every
 * container follows its campaign group's master config — no Follow or
 * Make master config on a row).
 * For Media Devoted | Created By Ciro Autiero
 */
import { getApiErrorMessage } from '@/lib/utils';
import { useToast } from '@/providers/ToastProvider';

import { useDropGeneratorMutations } from '../../../useDropGeneratorMutations';

export function useBoardActions() {
  const { duplicateContainer, removeContainer, setContainerEnabled } = useDropGeneratorMutations();
  const { error, success } = useToast();

  const duplicate = async (id: string) => {
    try {
      await duplicateContainer.mutateAsync(id);
      success('Container duplicated', 'The copy is disabled and last in order.');
    } catch (err) {
      error('Could not duplicate', getApiErrorMessage(err));
    }
  };

  const remove = async (id: string, name: string) => {
    try {
      await removeContainer.mutateAsync(id);
      success('Container deleted', `${name} was removed from the plan.`);
    } catch (err) {
      error('Could not delete container', getApiErrorMessage(err));
    }
  };

  return {
    duplicate,
    duplicating: duplicateContainer.isPending,
    remove,
    removing: removeContainer.isPending,
    setContainerEnabled,
  };
}
